import veiculoRoute from './veiculo';
import motoristaRoute from './motorista';
import competenciaRoute from './competencia';
import rotaRoute from './rota';
import contratoRoute from './contrato';
import frequenciaRoute from './frequencia';
import marcaRoute from './marca';
import modeloRoute from './modelo';
import categoriaVeiculoRoute from './categoria_veiculo';
import capturaRoute from './captura';

export default {
  veiculoRoute,
  motoristaRoute,
  competenciaRoute,
  rotaRoute,
  contratoRoute,
  frequenciaRoute,
  marcaRoute,
  modeloRoute,
  categoriaVeiculoRoute,
  capturaRoute,
};
